import { authUrl, baseUrl } from '@/api/types';

export function changeActiveCompanyUrl(companyId) {
  return `${authUrl}/change-company/${companyId}`;
}

export function companyCreateUrl() {
  return `${baseUrl}/companies/create`;
}

export function companyStoreUrl() {
  return `${baseUrl}/companies`;
}

export function companyCertificateFileUrl() {
  return `${baseUrl}/companies/certificate-file`;
}

export function companyDeleteCreateUrl(companyId) {
  return `${baseUrl}/company-delete/${companyId}/create`;
}
export function companyDeleteUrl(companyId) {
  return `${baseUrl}/company-delete/${companyId}`;
}

export function companyLeaveUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/leave`;
}

export function companyArchiveUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/archive`;
}

export function companyEditUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/edit`;
}

export function companyUpdateUrl(companyId) {
  return `${baseUrl}/companies/${companyId}`;
}

export function companyVats() {
  return `${baseUrl}/companies/vats`;
}

export function companyVatsUpdate() {
  return `${baseUrl}/companies/vats/update`;
}

export function companyUnitModalEditUrl() {
  return `${baseUrl}/modals/units`;
}

export function companyUnitModalUpdateUrl() {
  return `${baseUrl}/modals/units`;
}

export function companyVatModalUrl(type) {
  return `${baseUrl}/modals/company-vats/${type}`;
}

export function companyProductModalEditUrl() {
  return `${baseUrl}/modals/product-categories/edit`;
}

export function companyProductModalUpdateUrl() {
  return `${baseUrl}/modals/product-categories`;
}

export function companyMailEditUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/mail/edit`;
}

export function companyMailUpdateUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/mail`;
}

export function companyEmailConfirmUrl() {
  return `${baseUrl}/company-emails/confirmation/resend`;
}

export function userEmailConfirmUrl() {
  return `${baseUrl}/user-emails/confirmation/resend`;
}


export function companyUnitCurrencyEditUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/units-and-currencies/edit`;
}

export function companyUnitCurrencyUpdateUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/units-and-currencies`;
}

export function companyBankEditUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/bank/edit`;
}

export function companyBankStoreUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/bank`;
}

export function companyBankUpdateUrl(companyId, companyBankId) {
  return `${baseUrl}/companies/${companyId}/bank/${companyBankId}`;
}

export function companyBankDeleteUrl(companyId, companyBankId) {
  return `${baseUrl}/companies/${companyId}/bank/${companyBankId}`;
}

export function companySeriesSingleUpdateUrl(seriesId) {
  return `${baseUrl}/companies/series/${seriesId}/update-single`;
}

export function companySeriesSingleStoreUrl() {
  return `${baseUrl}/companies/series/store-single`;
}

export function companySeriesSingleCheckDeleteUrl(seriesId) {
  return `${baseUrl}/companies/series/${seriesId}/check-delete-single`;
}

export function companySeriesSingleDeleteUrl(seriesId) {
  return `${baseUrl}/companies/series/${seriesId}/delete-single`;
}

export function companyRegistersStoreUrl() {
  return `${baseUrl}/companies/registers/update`;
}

export function companySeriesEditUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/series/edit`;
}

export function companySeriesUpdateUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/series`;
}

export function companyExpenseEditUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/expense/edit`;
}

export function companyExpenseUpdateUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/expense`;
}

export function companyInvoiceEditUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/invoice/edit`;
}

export function companyInvoiceUpdateUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/invoice`;
}

export function companyInvoiceLogoBottomFileUrl() {
  return `${baseUrl}/companies/invoice-logo-file`;
}

export function companySeriesModalEditUrl(companyId, type = null) {
  return `${baseUrl}/modals/companies/${companyId}/series/edit?type=${type}`;
}

export function companyCashRegisterModalEditUrl(companyId) {
  return `${baseUrl}/modals/companies/${companyId}/cash-registers/edit`;
}

export function companyCashRegisterModalUpdateUrl(companyId) {
  return `${baseUrl}/modals/companies/${companyId}/cash-registers`;
}

export function companyCurrencyModalEditUrl(companyId) {
  return `${baseUrl}/modals/companies/${companyId}/currency/edit`;
}

export function companyCurrencyModalUpdateUrl(companyId) {
  return `${baseUrl}/modals/companies/${companyId}/currency`;
}

export function companyChartSettingIndexUrl() {
  return `${baseUrl}/company-chart-settings`;
}

export function referralIndexUrl() {
  return `${baseUrl}/referral`;
}

export function referralEmailStoreUrl() {
  return `${baseUrl}/referral-emails/store`;
}

export function nordigenBanksUrl(countryId) {
  return `${baseUrl}/nordigen/banks/${countryId}`;
}

export function nordigenBankLinkUrl() {
  return `${baseUrl}/nordigen/bank-link`;
}

export function nordigenBankLinkUpdatedUrl(hashedId) {
  return `${baseUrl}/nordigen/bank-link/${hashedId}`;
}

export function nordigenDeleteUrl(id) {
  return `${baseUrl}/nordigen/${id}`;
}

export function companyIvCalculatorSettingsIndexUrl() {
  return `${baseUrl}/company-iv-calculator-settings`;
}

export function companySignatureFileStoreUrl() {
  return `${baseUrl}/company-signatures/files`;
}

export function companyUserSignatureFileStoreUrl() {
  return `${baseUrl}/company-user-signatures/files`;
}

export function companyLogotypeEditUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/logotype/edit`;
}

export function companyLogotypeUpdateUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/logotype`;
}

export function companyStatisticEditUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/statistic/edit`;
}

export function companyStatisticUpdateUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/statistic`;
}

export function companyPdfTemplatesEditUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/pdf-templates/edit`;
}

export function companyLanguageEditUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/language/edit`;
}

export function companyLanguageUpdateUrl(companyId) {
  return `${baseUrl}/companies/${companyId}/language`;
}

export function companiesListEditUrl() {
  return `${baseUrl}/companies/list`;
}

export function companyUsersPermissionsEditUrl() {
  return `${baseUrl}/companies/users-permissions`;
}
